<template>
    
    <div class="">
        <!-- Summary -->
        <div class="row">
            <div class="col-md-6">
                <div class="input-group flex-nowrap p-1 border-0 border-end" :class="[light.border]" style="cursor: default;">
                    <div class="btn me-1" :class=[light.text,light.border,light.back] style="align-items: center; display:flex; width: 20%">
                        <i class="fa-solid text-primary fa-location-dot me-2" style="font-size: 25px;"></i>
                        <div class="w-100 text-start fw-light fs-4">
                            Sites
                        </div>
                    </div>
                    <div class="btn me-1" :class=[light.text,light.border,light.back] title="Connected sites." style="width: 20%;">
                        <div class="fa-solid fa-circle-check text-success" style="font-size: 20px;"></div>
                        <div class="w-100">
                            {{maindata.summary.sites.connected}}
                        </div>
                    </div>
                    <div class="btn me-1" :class=[light.text,light.border,light.back] title="Disconnected sites."  style="width: 20%;">
                        <div class="fa-solid fa-circle-xmark text-danger" style="font-size: 20px;"></div>
                        <div class="w-100">
                            {{maindata.summary.sites.disconnected}}
                        </div>
                    </div>
                    <div class="btn me-1" :class=[light.text,light.border,light.back] title="Disabled sites." style="width: 20%;">
                        <div class="fa-solid fa-ban" style="font-size: 20px;"></div>
                        <div class="w-100">
                            {{maindata.summary.sites.disabled}}
                        </div>
                    </div>
                    <div class="btn fs-6" :class=[light.text,light.border,light.back] title="Total sites." style="width: 20%;">
                        <div class="fa-solid fa-t" style="font-size: 20px;"></div>
                        <div class="w-100">
                            {{maindata.summary.sites.total}}
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-6">
                <div class="input-group flex-nowrap p-1 border-0 border-start" :class="[light.border]" style="cursor: default;">
                    <div class="btn me-1" :class=[light.text,light.border,light.back] style="align-items: center; display:flex; width: 25%">
                        <i class="fa-solid text-primary fa-server me-2" style="font-size: 25px;"></i>
                        <div class="w-100 text-start fw-light fs-4">
                            Devices
                        </div>
                    </div>
                    <div class="btn me-1" :class="[light.text, light.back, light.border]" title="Connected devices." style="width: 25%;">
                        <div class="fa-solid text-success fa-circle-check" style="font-size: 20px;"></div>
                        <div class="w-100">
                            {{maindata.summary.devices.connected}}
                        </div>
                    </div>
                    <div class="btn me-1" :class="[light.text, light.back, light.border]" title="Disconnected devices." style="width: 25%;">
                        <div class="fa-solid text-danger fa-circle-xmark" style="font-size: 20px;"></div>
                        <div class="w-100">
                            {{maindata.summary.devices.disconnected}}
                        </div>
                    </div>
                    <div class="btn" :class=[light.text,light.border,light.back] title="Total devices." style="width: 25%;">
                        <div class="fa-solid fa-t" style="font-size: 20px;"></div>
                        <div class="w-100">
                            {{maindata.summary.devices.total}}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Countries, Map & Disconnected Sites. -->
        <div class="row mt-3">
            <div class="col-md-4">
                <div class="input-group flex-nowrap">
                    <div class="text-start fw-light fs-4" :class="[light.text]" style="letter-spacing: 3px; width: 50%;">
                        <i class="fa-solid text-primary fa-earth-americas"></i>
                        Countries
                    </div>
                    <input type="text" class="btn rounded fs-6" :class="[light.border,light.text, light.back]" style="width: 50%" placeholder="Search country..." v-model="country_word">
                </div>
                <div class="mt-1">
                    <div class="input-group flex-nowrap" style="overflow-y:scroll;">
                        <div class="btn text-start text-primary" :class="[light.border,light.header]" style="width: 40%; font-size: 13px;" title="Country name.">
                            <i class="fa-solid fa-globe"></i>
                        </div>
                        <div class="btn text-primary" :class="[light.border,light.header]" style="width: 16%; font-size: 13px;" title="Total sites.">
                            <i class="fa-solid fa-location-dot"></i>
                        </div>
                        <div class="btn text-success" :class="[light.border,light.header]" style="width: 16%; font-size: 13px;" title="Connected sites.">
                            <i class="fa-solid fa-circle-check"></i>
                        </div>
                        <div class="btn text-danger" :class="[light.border,light.header]" style="width: 16%; font-size: 13px;" title="Disconnected sites.">
                            <i class="fa-solid fa-circle-xmark"></i>
                        </div>
                        <div class="btn" :class="[light.border, light.text,light.header]" style="width: 16%; font-size: 13px;" title="Disabled sites.">
                            <i class="fa-solid fa-ban"></i>
                        </div>
                    </div>
                </div>
                <div class="rounded" :class="[light.border]" style="overflow-y: scroll; height: 484px">
                    <div v-for="(c,i) in countries" :key="i" class="input-group flex-nowrap" :class="[light.border]">
                        <div class="btn fw-bold text-start" :class="[light.text]" style="width: 40%; font-size: 11px; cursor:default;">
                            <img class="me-1" :src="getFlag(c.code)" width="30">
                            {{c.alias}}
                        </div>
                        <div class="btn" :class="[light.text]" style="width: 16%; font-size: 11px;">
                            {{c.total}}
                        </div>
                        <div class="btn" :class="[light.text]" style="width: 16%; font-size: 11px;">
                            {{c.connected}}
                        </div>
                        <div class="btn" :class="[light.text]" style="width: 16%; font-size: 11px;">
                            {{c.disconnected}}
                        </div>
                        <div class="btn" :class="[light.text]" style="width: 16%; font-size: 11px;">
                            {{c.disabled}}
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-8">
                <div class="text-start fw-light fs-4 mb-1" :class="[light.text]" style="letter-spacing: 3px;">
                    <i class="fa-solid fa-globe text-primary"></i>
                    Geolocation
                </div>
                <div class="rounded" :class="[light.border]" style="height: 230px;">
                    <SiteMap :key="mapSettings.key" :mapkey="mapkey" mapHeight="230"  :mapSettings="mapSettings" :markers="maindata.geolocation" :icons="icons" />
                </div>
                <div class="text-start mt-1 fs-4 fw-light" :class="[light.text]" style="letter-spacing: 3px;">
                    <i class="fa-solid fa-circle-xmark text-danger"></i>
                    Disconnected Sites {{`(${disconnected.length})`}}
                </div>
                <div class="rounded" style="height: 250px;">
                    <div>
                        <div class="input-group flex-nowrap" style="overflow-y:scroll;" :class="[light.border,light.header]">
                            <div class="btn text-start text-primary" style="width: 20%; font-size: 15px;" title="Country name.">
                                <i class="fa-solid fa-globe"></i>
                            </div>
                            <div class="btn text-start" :class="[light.text,light.header]" style="width: 30%; font-size: 15px;" title="Site name.">
                                <i class="fa-solid fa-id-badge" ></i>
                            </div>
                            <div class="btn text-start" :class="[light.text,light.header]" style="width: 20%; font-size: 15px;" title="Pop name.">
                                <i class="fa-solid fa-object-group"></i>
                            </div>
                            <div class="btn" :class="[light.text,light.header]" style="width: 5%; font-size: 15px;" title="Operational Status">
                                <i class="fa-solid fa-heart-pulse"></i>
                            </div>
                            <div class="btn" :class="[light.text,light.header]" style="width: 5%; font-size: 15px;" title="Connectivity Status">
                                <i class="fa-solid fa-signal"></i>
                            </div>
                            <div class="btn" :class="[light.text,light.header]" style="width: 20%; font-size: 15px;" title="Last Connection">
                                <i class="fa-solid fa-calendar-day"></i>
                            </div>
                        </div>
                    </div>
                    <div :class="[light.border]" style="overflow-y:scroll; height: 210px;">
                        <div class="input-group flex-nowrap" :class="[light.border_bottom]" v-for="(ds, is) in disconnected" :key="is">
                            <div class="btn fw-bold text-start" :class="[light.text]" style="width: 20%; font-size: 12px;" title="Country name.">
                                {{ds.alias}}
                            </div>
                            <div class="btn text-start" :class="[light.text]" style="width: 30%; font-size: 11px; word-wrap: break-word;" title="Site name.">
                                {{ds.sitename}}
                            </div>
                            <div class="btn text-start" :class="[light.text]" style="width: 20%; font-size: 11px;" title="Pop name.">
                                {{ds.popname}}
                            </div>
                            <div class="btn" :class="[light.text]" style="width: 5%; font-size: 20px;" title="Operational Status">
                                <i class="fa-solid" :class="{'fa-circle-check text-success': ds.operational, 'fa-circle-xmark text-danger': !ds.operational}"></i>
                            </div>
                            <div class="btn" :class="[light.text]" style="width: 5%; font-size: 20px;" title="Connectivity Status">
                                <i class="fa-solid" :class="{'fa-circle-check text-success': ds.connectivity, 'fa-circle-xmark text-danger': !ds.connectivity}"></i>
                            </div>
                            <div class="btn" :class="[light.text]" style="width: 20%; font-size: 12px;" title="Disabled sites.">
                                {{ds.timestamp}}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Internet Services. -->
        <div class="row mt-4">
            <div class="col-md-4">
                <div class="text-start fs-4 fw-light" :class="[light.text]" style="letter-spacing: 3px;">
                    <i class="fa-solid text-primary fa-earth-americas"></i>
                    Internet Services
                </div>
            </div>
            <div class="col-md-3"></div>
            <div class="col-md-5">
                <div class="text-end fs-6 fw-light mt-2" :class="[light.text]" style="align-content: center;">
                    <i class="fa-solid text-warning fa-circle-info"></i>
                    An Internet service is considered degraded when it doesn't have a tunnel.
                </div>
            </div>
        </div>
        <div class="row mt-1">
            <div class="col-md-4">
                <!-- Summary -->
                <div class="input-group flex-nowrap rounded">
                    <div class="btn me-1" :class="[light.back, light.border]" title="Connected Services" style="width: 34%">
                        <i class="fa-solid fa-circle-check text-success" style="font-size: 23px;"></i>
                        <div :class="[light.text]">{{maindata.internet.summary.connected}}</div>
                    </div>
                    <div class="btn" :class="[light.back,light.border]" title="Disconnected Services" style="width: 34%">
                        <i class="fa-solid fa-circle-xmark text-danger" style="font-size: 23px;"></i>
                        <div :class="[light.text]">{{maindata.internet.summary.disconnected}}</div>
                    </div>
                    <div class="btn ms-1" :class="[light.back,light.border]" title="Total Services" style="width: 34%">
                        <i class="fa-solid fa-t" :class="[light.text]" style="font-size: 23px;"></i>
                        <div :class="[light.text]">{{maindata.internet.summary.total}}</div>
                    </div>
                </div>
                <!-- Bars -->
                <div class="rounded mt-1" :class="[light.border]" style="height: 357px; overflow-y: scroll;">
                    <div class="input-group flex-nowrap mb-1" v-for="(bd, bi) in maindata.internet.bars" :key="bi">
                        <div class="btn fw-bold text-start font-italic" :class="[light.text, light.border]" style="width: 30%; font-size: 11px;">
                            {{bd.alias}}
                        </div>
                        <div class="btn fw-bold me-1" :class="[light.text, light.border]" style="width: 10%; font-size: 11px;">
                            {{bd.total}}
                        </div>
                        <div class="input-group flex-nowrap" :style="`width: ${ bd.total * (60 / getMax(maindata.internet.bars, 'total'))}%`">
                            <div class="bg-success text-white" style="height: 100%; align-content: center; cursor: default;" :style="`width: ${(bd.connected / bd.total) * 100}%`" :title="`ISP: ${bd.alias}\nConnected: ${bd.connected}\nDisconnected: ${bd.disconnected}\nTotal: ${bd.total}`">
                                <span class="fw-bold" style="font-size: 12px;">{{bd.connected > 20 ? bd.connected:null}}</span>
                            </div>
                            <div class="bg-danger text-white" style="height: 100%; align-content: center; cursor: default;" :style="`width: ${(bd.disconnected / bd.total) * 100}%`" :title="`ISP: ${bd.alias}\nConnected: ${bd.connected}\nDisconnected: ${bd.disconnected}\nTotal: ${bd.total}`">
                                <span class="fw-bold" style="font-size: 12px;">{{bd.disconnected > 20  ? bd.disconnected:null}}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-8">
                <!-- Disconnected Services -->
                <div class="input-group flex-nowrap">
                    <div class="text-start fw-light fs-6 mb-1" :class="[light.text]" style="letter-spacing: 3px; width: 30%;">
                        <i class="fa-solid fa-circle-xmark text-danger"></i>
                        Disconnected Services
                    </div>
                    <input type="text" v-model="internet_disconnected_word" class="btn rounded" :class="[light.text,light.border,light.back]" placeholder="Search site..." style="height: 30px; width: 30%; cursor: text;">
                </div>
                <div class="mt-2">
                    <div class="input-group flex-nowrap" :class="[light.border]" style="overflow-y:scroll;">
                        <div class="btn text-start" :class="[light.text,light.header]" style="width: 20%; font-size: 15px;" title="Interface name.">
                            <i class="fa-solid fa-ethernet"></i>
                        </div>
                        <div class="btn text-start" :class="[light.text,light.header]" style="width: 20%; font-size: 15px;" title="Pop name.">
                            <i class="fa-solid fa-object-group"></i>
                        </div>
                        <div class="btn text-start" :class="[light.text,light.header]" style="width: 20%; font-size: 15px;" title="Provider">
                            <i class="fa-solid fa-location-dot"></i>
                        </div>
                        <div class="btn text-start" :class="[light.text,light.header]" style="width: 20%; font-size: 15px;" title="Tunnel Remote IP.">
                            <i class="fa-solid fa-network-wired"></i>
                        </div>
                        <div class="btn text-start" :class="[light.text,light.header]" style="width: 20%; font-size: 15px;" title="Provider">
                            <i class="fa-solid fa-gears"></i>
                        </div>
                    </div>
                </div>
                <div style="overflow-y:scroll; height: 350px;" :class="[light.border]">
                    <div class="input-group flex-nowrap" :class="[light.border_bottom]" v-for="(ds, dsi) in internet_disconnected" :key="dsi">
                        <div class="btn fw-bold text-start" :class="[light.text]" style="width: 20%; font-size: 12px;" title="Interface name.">
                            {{ds.interface}}
                        </div>
                        <div class="btn text-start" :class="[light.text]" style="width: 20%; font-size: 12px;" title="Pop name.">
                            {{ds.popname}}
                        </div>
                        <div class="btn text-start" :class="[light.text]" style="width: 20%; font-size: 13px;" title="Provider">
                            {{ds.popname}}
                        </div>
                        <div class="btn text-start" :class="[light.text]" style="width: 20%; font-size: 13px;" title="Tunnel Remote IP.">
                            {{ds.tunnel}}
                        </div>
                        <div class="btn text-start" :class="[light.text]" style="width: 20%; font-size: 13px;" title="Provider">
                            {{ds.provider}}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Custom Apps -->
        <div class="row mt-4">
            <div class="col-md-12">
                <div class="input-group flex-nowrap">
                    <div class="text-start fs-4 fw-light mt-2" :class="[light.text]" style="letter-spacing: 3px; width: 25%">
                        <i class="fa-solid text-primary fa-boxes-stacked"></i>
                        Custom Apps
                    </div>
                    <div class="" style="width: 75%;">
                        <div class="btn me-1" :class="[light.back, light.border]" title="RTT references" style="width: 24%">
                            <div class="input-group flex-nowrap">
                                <div class="fw-bold text-start" :class="[light.text]" style="letter-spacing: 3px; width: 25%; font-size: 13px;">RTT</div>
                                <div style="width: 25%" title="Good">
                                    <i class="fa-solid fa-circle-check text-success" style="font-size: 15px;"></i>
                                    <div :class="[light.text]" style="font-size: 13px;">50</div>
                                </div>
                                <div style="width: 25%" title="Fair">
                                    <i class="fa-solid fa-triangle-exclamation text-warning" style="font-size: 15px;"></i>
                                    <div :class="[light.text]" style="font-size: 13px;">100</div>
                                </div>
                                <div style="width: 25%" title="Poor">
                                    <i class="fa-solid fa-circle-xmark text-danger" style="font-size: 15px;"></i>
                                    <div :class="[light.text]" style="font-size: 13px;">>100</div>
                                </div>
                            </div>
                        </div>
                        <div class="btn me-1" :class="[light.back, light.border]" title="Jitter references" style="width: 24%">
                            <div class="input-group flex-nowrap">
                                <div class="fw-bold text-start" :class="[light.text]" style="letter-spacing: 3px; width: 25%; font-size: 13px;">Jitter</div>
                                <div style="width: 25%">
                                    <i class="fa-solid fa-circle-check text-success" style="font-size: 15px;"></i>
                                    <div :class="[light.text]" style="font-size: 13px;">20</div>
                                </div>
                                <div style="width: 25%">
                                    <i class="fa-solid fa-triangle-exclamation text-warning" style="font-size: 15px;"></i>
                                    <div :class="[light.text]" style="font-size: 13px;">50</div>
                                </div>
                                <div style="width: 25%">
                                    <i class="fa-solid fa-circle-xmark text-danger" style="font-size: 15px;"></i>
                                    <div :class="[light.text]" style="font-size: 13px;">>50</div>
                                </div>
                            </div>
                        </div>
                        <div class="btn me-1" :class="[light.back, light.border]" title="Packet Loss references" style="width: 25%">
                            <div class="input-group flex-nowrap">
                                <div class="fw-bold text-start" :class="[light.text]" style="letter-spacing: 3px; width: 25%; font-size: 12px;">Packet Loss</div>
                                <div style="width: 25%">
                                    <i class="fa-solid fa-circle-check text-success" style="font-size: 15px;"></i>
                                    <div :class="[light.text]" style="font-size: 13px;">10</div>
                                </div>
                                <div style="width: 25%">
                                    <i class="fa-solid fa-triangle-exclamation text-warning" style="font-size: 15px;"></i>
                                    <div :class="[light.text]" style="font-size: 13px;">20</div>
                                </div>
                                <div style="width: 25%">
                                    <i class="fa-solid fa-circle-xmark text-danger" style="font-size: 15px;"></i>
                                    <div :class="[light.text]" style="font-size: 13px;">>20</div>
                                </div>
                            </div>
                        </div>
                        <div class="btn" :class="[light.back, light.border]" title="Discarded Packets references" style="width: 25%">
                            <div class="input-group flex-nowrap">
                                <div class="fw-bold text-start" :class="[light.text]" style="letter-spacing: 3px; width: 40%; font-size: 12px;">Discarded Packets</div>
                                <div style="width: 20%">
                                    <i class="fa-solid fa-circle-check text-success" style="font-size: 15px;"></i>
                                    <div :class="[light.text]" style="font-size: 13px;">500</div>
                                </div>
                                <div style="width: 20%">
                                    <i class="fa-solid fa-triangle-exclamation text-warning" style="font-size: 15px;"></i>
                                    <div :class="[light.text]" style="font-size: 13px;">1000</div>
                                </div>
                                <div style="width: 20%">
                                    <i class="fa-solid fa-circle-xmark text-danger" style="font-size: 15px;"></i>
                                    <div :class="[light.text]" style="font-size: 13px;">>1000</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row mt-2">
            <div class="col-md-5">
                <div>
                    <div class="text-start bold" :class="[light.text]" style="align-content: center; font-size: 15px;">
                        User Experience in Custom Applications
                    </div>
                    <div class="text-start fw-bold" :class="[light.text]" style="align-content: center; font-size: 11px;">
                        <i class="fa-solid text-warning fa-circle-info"></i>
                        Good is rated (1), Fair is rated (2), Poor is rated (3) and so they are averaged.
                    </div>
                </div>
                <div>
                    <div class="input-group flex-nowrap" style="overflow-y:scroll;">
                        <div class="btn text-start" :class="[light.border,light.text,light.header]" style="width: 41%; font-size: 15px;" title="Application.">
                            <i class="fa-solid fa-box"></i>
                        </div>
                        <div class="btn" :class="[light.border,light.text,light.header]" style="width: 30%; font-size: 15px;" title="Average RTT & Jitter">
                            Avg |
                            <i class="fa-solid fa-clock"></i>
                            |
                            <i class="fa-solid fa-timeline"></i>
                        </div>
                        <div class="btn" :class="[light.border,light.text,light.header]" style="width: 30%; font-size: 15px;" title="Average RTT, Jitter, Loss, Discarded">
                            Avg |
                            <i class="fa-solid fa-clock"></i>
                            |
                            <i class="fa-solid fa-timeline"></i>
                            |
                            <i class="fa-solid fa-arrow-trend-down"></i>
                            |
                            <i class="fa-solid fa-trash"></i>
                        </div>
                    </div>
                </div>
                <div class="rounded" style="overflow-y:scroll; height: 520px;" :class="[light.border]">
                    <div v-for="(app, appi) in maindata.custom_apps.applications" :key="appi" :class="[light.border]">
                        <div class="input-group flex-nowrap">
                            <div class="btn text-start text-success" style="width: 4%;">
                                <i class="fa-solid" :class="{'fa-square-plus': !app.open,'fa-square-minus': app.open}" @click="app.open = !app.open"></i>
                            </div>
                            <div class="btn text-start fw-bold" :class="[light.text]" style="width: 37%; font-size: 9px; cursor: default;" title="Application name.">
                                {{app.name}}
                            </div>
                            <div class="btn fw-bold text-end" :class="[light.text]" style="width: 30%; font-size: 13px;" title="Average RTT & Jitter">
                                {{app.avg_rj}}
                            </div>
                            <div class="btn fw-bold text-end" :class="[light.text]" style="width: 30%; font-size: 13px;" title="Average RTT, Jitter, Loss, Discarded">
                                {{app.avg_rjld}}
                            </div>
                        </div>
                        <div v-if="app.open">
                            <div v-for="(subdata, subi) in app.data" :key="subi">
                                <div class="input-group flex-nowrap" :class="[light.border]">
                                    <div class="btn text-start text-black" style="width: 4%;">
                                        <i class="fa-solid"  @click="app.open = !app.open"></i>
                                    </div>
                                    <div class="btn text-start" :class="[light.text]" style="width: 37%; font-size: 9px; cursor: default;" title="Username.">
                                        {{subdata.name}}
                                    </div>
                                    <div class="btn text-end" :class="[light.text]" style="width: 30%; font-size: 13px;" title="Average RTT & Jitter">
                                        {{subdata.avg_rj}}
                                    </div>
                                    <div class="btn text-end" :class="[light.text]" style="width: 30%; font-size: 13px;" title="Average RTT, Jitter, Loss, Discarded">
                                        {{subdata.avg_rjld}}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-7">
                <div>
                    <div class="text-start bold" :class="[light.text]" style="align-content: center; font-size: 17px;">
                        <i class="fa-solid text-primary fa-award"></i>
                        TOP 10 Flows Created - By User
                    </div>
                </div>
                <div class="rounded p-2 mt-1" :class="[light.border]" style="height: 260px; overflow-y:scroll;">
                    <div class="input-group flex-nowrap mb-1" v-for="(td, ti) in maindata.custom_apps.topflows" :key="ti">
                        <div class="btn fw-bold text-end font-italic" :class="[light.text]" style="width: 15%; font-size: 14px;">
                            {{td.user}}
                        </div>
                        <div class="input-group flex-nowrap" :style="`width: ${ td.flows * (80 / getMax(maindata.custom_apps.topflows, 'flows'))}%`">
                            <div class="bg-bar text-black rounded" style="height: 100%; align-content: center; cursor: default; font-size:10px;" :style="`width: ${(td.flows / getMax(maindata.custom_apps.topflows, 'flows')) * 100}%`" :title="`User: ${td.user}\nFlows: ${td.flows}`">
                            </div>
                            <div class="btn fw-bold text-start ms-2" style="width: 5%; font-size: 13px;" :class="[light.text]">{{td.flows}}</div>
                        </div>
                    </div>
                </div>
                <div class="mt-3">
                    <div class="text-start bold" :class="[light.text]" style="align-content: center; font-size: 17px;">
                        <i class="fa-solid text-warning fa-award"></i>
                        TOP Host Using App
                    </div>
                </div>
                <div style="overflow-y:scroll;">
                    <div class="input-group flex-nowrap">
                        <div class="btn text-start" :class="[light.border,light.text,light.header]" style="width: 20%; font-size: 11px;" title="Username">
                            <i class="fa-solid fa-user"></i>
                        </div>
                        <div class="btn text-start" :class="[light.border, light.text,light.header]" style="width: 40%; font-size: 11px;" title="Application Name">
                            <i class="fa-solid fa-box"></i>
                        </div>
                        <div class="btn" :class="[light.border,light.text,light.header]" style="width: 10%; font-size: 11px;" title="Flows">
                            <i class="fa-solid fa-water"></i>
                        </div>
                        <div class="btn" :class="[light.border,light.text,light.header]" style="width: 40%; font-size: 11px;" title="Device Name">
                            <i class="fa-solid fa-server"></i>
                        </div>
                        <div class="btn" :class="[light.border,light.text,light.header]" style="width: 10%; font-size: 11px;" title="Traffic in MB.">
                            <i class="fa-solid fa-up-down"></i>
                        </div>
                        <div class="btn text-end" :class="[light.border,light.text,light.header]" style="width: 40%; font-size: 11px;" title="Site">
                            <i class="fa-solid fa-location-dot"></i>
                        </div>
                    </div>
                </div>
                <div class="rounded" style="height: 200px; overflow-y:scroll;">
                    <div class="input-group flex-nowrap mt-1" v-for="(tpa, tpi) in maindata.custom_apps.topapps" :key="tpi">
                        <div class="btn fw-bold text-start" :class="[light.border, light.text]" style="width: 20%; font-size: 10px;" title="Username">
                            {{tpa.user}}
                        </div>
                        <input type="text" class="btn text-start" :class="[light.border, light.text]" style="width: 40%; font-size: 10px;" title="Application Name" :value="tpa.application" readonly>
                        <div v-if="false" class="btn text-start" :class="[light.border, light.text]" style="width: 40%; font-size: 10px;" title="Application Name">
                            {{tpa.application}}
                        </div>
                        <div class="btn fw-bold" :class="[light.border,light.text]" style="width: 10%; font-size: 10px;" title="Flows">
                            {{tpa.flows}}
                        </div>
                        <div class="btn" :class="[light.border,light.text]" style="width: 40%; font-size: 10px;" title="Device Name">
                            {{tpa.device}}
                        </div>
                        <div class="btn fw-bold" :class="[light.border,light.text]" style="width: 10%; font-size: 10px;" title="Traffic in MB.">
                            {{tpa.traffic}}
                        </div>
                        <input type="text" class="btn text-end fw-bold" :class="[light.border, light.text]" style="width: 40%; font-size: 10px;" title="Site" :value="tpa.site" readonly>
                        <div v-if="false" class="btn text-end fw-bold" :class="[light.border,light.text]" style="width: 40%; font-size: 10px;" title="Site" :value="tpa.site" readonly>
                            {{tpa.site}}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Network Metrics -->
        <div class="row mt-4">
            <div class="col-md-12">
                <div class="input-group flex-nowrap">
                    <div class="text-start fs-4 fw-light mt-2" :class="[light.text]" style="letter-spacing: 3px; width: 25%">
                        <i class="fa-solid text-primary fa-network-wired"></i>
                        Network Metrics
                    </div>
                    <div class="" style="width: 75%;">
                        <div>
                            <div class="text-start fw-bold" :class="[light.text]" style="align-content: center; font-size: 11px;">
                                <i class="fa-solid text-warning fa-circle-info"></i>
                                Good is rated (1), Fair is rated (2), Poor is rated (3) and so they are averaged.
                            </div>
                        </div>
                        <div class="btn me-1" :class="[light.back, light.border]" title="RTT references" style="width: 24%">
                            <div class="input-group flex-nowrap">
                                <div class="fw-bold text-start" :class="[light.text]" style="letter-spacing: 3px; width: 25%; font-size: 13px;">RTT</div>
                                <div style="width: 25%" title="Good">
                                    <i class="fa-solid fa-circle-check text-success" style="font-size: 15px;"></i>
                                    <div :class="[light.text]" style="font-size: 13px;">50</div>
                                </div>
                                <div style="width: 25%" title="Fair">
                                    <i class="fa-solid fa-triangle-exclamation text-warning" style="font-size: 15px;"></i>
                                    <div :class="[light.text]" style="font-size: 13px;">100</div>
                                </div>
                                <div style="width: 25%" title="Poor">
                                    <i class="fa-solid fa-circle-xmark text-danger" style="font-size: 15px;"></i>
                                    <div :class="[light.text]" style="font-size: 13px;">>100</div>
                                </div>
                            </div>
                        </div>
                        <div class="btn me-1" :class="[light.back, light.border]" title="Jitter references" style="width: 24%">
                            <div class="input-group flex-nowrap">
                                <div class="fw-bold text-start" :class="[light.text]" style="letter-spacing: 3px; width: 25%; font-size: 13px;">Jitter</div>
                                <div style="width: 25%">
                                    <i class="fa-solid fa-circle-check text-success" style="font-size: 15px;"></i>
                                    <div :class="[light.text]" style="font-size: 13px;">20</div>
                                </div>
                                <div style="width: 25%">
                                    <i class="fa-solid fa-triangle-exclamation text-warning" style="font-size: 15px;"></i>
                                    <div :class="[light.text]" style="font-size: 13px;">50</div>
                                </div>
                                <div style="width: 25%">
                                    <i class="fa-solid fa-circle-xmark text-danger" style="font-size: 15px;"></i>
                                    <div :class="[light.text]" style="font-size: 13px;">>50</div>
                                </div>
                            </div>
                        </div>
                        <div class="btn me-1" :class="[light.back, light.border]" title="Packet Loss references" style="width: 25%">
                            <div class="input-group flex-nowrap">
                                <div class="fw-bold text-start" :class="[light.text]" style="letter-spacing: 3px; width: 25%; font-size: 12px;">Packet Loss</div>
                                <div style="width: 25%">
                                    <i class="fa-solid fa-circle-check text-success" style="font-size: 15px;"></i>
                                    <div :class="[light.text]" style="font-size: 13px;">10</div>
                                </div>
                                <div style="width: 25%">
                                    <i class="fa-solid fa-triangle-exclamation text-warning" style="font-size: 15px;"></i>
                                    <div :class="[light.text]" style="font-size: 13px;">20</div>
                                </div>
                                <div style="width: 25%">
                                    <i class="fa-solid fa-circle-xmark text-danger" style="font-size: 15px;"></i>
                                    <div :class="[light.text]" style="font-size: 13px;">>20</div>
                                </div>
                            </div>
                        </div>
                        <div class="btn" :class="[light.back, light.border]" title="Discarded Packets references" style="width: 25%">
                            <div class="input-group flex-nowrap">
                                <div class="fw-bold text-start" :class="[light.text]" style="letter-spacing: 3px; width: 40%; font-size: 12px;">Discarded Packets</div>
                                <div style="width: 20%">
                                    <i class="fa-solid fa-circle-check text-success" style="font-size: 15px;"></i>
                                    <div :class="[light.text]" style="font-size: 13px;">500</div>
                                </div>
                                <div style="width: 20%">
                                    <i class="fa-solid fa-triangle-exclamation text-warning" style="font-size: 15px;"></i>
                                    <div :class="[light.text]" style="font-size: 13px;">1000</div>
                                </div>
                                <div style="width: 20%">
                                    <i class="fa-solid fa-circle-xmark text-danger" style="font-size: 15px;"></i>
                                    <div :class="[light.text]" style="font-size: 13px;">>1000</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row mt-2">
            <div>
                <div style="overflow-y:scroll;">
                    <div class="input-group flex-nowrap">
                        <div class="btn text-start" :class="[light.border,light.text,light.header]" style="width: 22%; font-size: 12px;" title="Country">
                            <i class="fa-solid text-primary fa-globe"></i>
                            |
                            <i class="fa-solid text-primary fa-location-dot"></i>
                        </div>
                        <div class="btn fw-bold" :class="[light.border,light.text,light.header]" style="width: 7%; font-size: 12px;">
                            RTT
                        </div>
                        <div class="btn fw-bold" :class="[light.border,light.text,light.header]" style="width: 7%; font-size: 12px;">
                            Jitter Upstream
                        </div>
                        <div class="btn fw-bold" :class="[light.border,light.text,light.header]" style="width: 7%; font-size: 12px;">
                            Jitter Downstream
                        </div>
                        <div class="btn fw-bold" :class="[light.border,light.text,light.header]" style="width: 10%; font-size: 12px;">
                            Lost Upstream PCNT
                        </div>
                        <div class="btn fw-bold" :class="[light.border,light.text,light.header]" style="width: 10%; font-size: 12px;">
                            Lost Downstream PCNT
                        </div>
                        <div class="btn fw-bold" :class="[light.border,light.text,light.header]" style="width: 10%; font-size: 12px;">
                            Packets Discarded Upstream
                        </div>
                        <div class="btn fw-bold" :class="[light.border,light.text,light.header]" style="width: 10%; font-size: 12px;">
                            Packets Discarded Downstream
                        </div>
                        <div class="btn fw-bold" :class="[light.border,light.text,light.header]" style="width: 10%; font-size: 12px;">
                            UX (RTT & Jitter)
                        </div>
                        <div class="btn fw-bold" :class="[light.border,light.text,light.header]" style="width: 10%; font-size: 12px;">
                            UX (RTT, Jitter, Lost, Discarded)
                        </div>
                    </div>
                </div>
                <div style="overflow-y:scroll; height: 520px;" :class="[light.border]">
                    <div v-for="(cd, ci) in maindata.network_metrics.data" :key="ci" :class="[light.border]">
                        <div class="input-group flex-nowrap">
                            <div class="btn" style="width: 2%;">
                                <i class="fa-solid text-primary" :class="{'fa-square-plus': !cd.open,'fa-square-minus': cd.open}" @click="cd.open = !cd.open"></i>
                            </div>
                            <div class="btn text-start" :class="[light.text]" style="width: 20%; font-size: 12px;" title="Country">
                                <img class="me-1" :src="getFlag(cd.code)" width="30">
                                <span class="fw-bold">{{` (${String(cd.nodetype).toUpperCase()})`}}</span>
                            </div>
                            <div class="btn text-end fw-bold" :class="[light.text]" style="width: 7%; font-size: 12px; align-items: center;" title="ms">
                                {{getAvg(cd.sites, 'rtt')}}
                            </div>
                            <div class="btn text-end fw-bold" :class="[light.text]" style="width: 7%; font-size: 12px;" title="ms">
                                {{getAvg(cd.sites, 'jitt_up')}}
                            </div>
                            <div class="btn text-end fw-bold" :class="[light.text]" style="width: 7%; font-size: 12px;" title="ms">
                                {{getAvg(cd.sites, 'jitt_dw')}}
                            </div>
                            <div class="btn text-end fw-bold" :class="[light.text]" style="width: 10%; font-size: 12px;">
                                {{getAvg(cd.sites, 'lost_up_pcnt')}}
                            </div>
                            <div class="btn text-end fw-bold" :class="[light.text]" style="width: 10%; font-size: 12px;">
                                {{getAvg(cd.sites, 'lost_dw_pcnt')}}
                            </div>
                            <div class="btn text-end fw-bold" :class="[light.text]" style="width: 10%; font-size: 12px;">
                                {{getAvg(cd.sites, 'pks_disc_up')}}
                            </div>
                            <div class="btn text-end fw-bold" :class="[light.text]" style="width: 10%; font-size: 12px;">
                                {{getAvg(cd.sites, 'pks_disc_dw')}}
                            </div>
                            <div class="btn text-end fw-bold" :class="[light.text]" style="width: 10%; font-size: 12px;">
                                {{getAvg(cd.sites, 'ux_rtt_jitt')}}
                            </div>
                            <div class="btn text-end fw-bold" :class="[light.text]" style="width: 10%; font-size: 12px;">
                                {{getAvg(cd.sites, 'ux_rjld')}}
                            </div>
                        </div>
                        <div v-if="cd.open">
                            <div class="input-group flex-nowrap" v-for="(st, si) in cd.sites" :key="si">
                                <div style="width: 2%;"></div>
                                <div class="btn text-start" :class="[light.text]" style="width: 20%; font-size: 12px;" title="Site Name">
                                    {{st.name}}
                                </div>
                                <div class="btn text-end fw-bold" :class="[light.text]" style="width: 7%; font-size: 12px;">
                                    {{st.rtt}}
                                </div>
                                <div class="btn text-end fw-bold" :class="[light.text]" style="width: 7%; font-size: 12px;">
                                    {{st.jitt_up}}
                                </div>
                                <div class="btn text-end fw-bold" :class="[light.text]" style="width: 7%; font-size: 12px;">
                                    {{st.jitt_dw}}
                                </div>
                                <div class="btn text-end fw-bold" :class="[light.text]" style="width: 10%; font-size: 12px;">
                                    {{st.lost_up_pcnt}}
                                </div>
                                <div class="btn text-end fw-bold" :class="[light.text]" style="width: 10%; font-size: 12px;">
                                    {{st.lost_dw_pcnt}}
                                </div>
                                <div class="btn text-end fw-bold" :class="[light.text]" style="width: 10%; font-size: 12px;">
                                    {{st.pks_disc_up}}
                                </div>
                                <div class="btn text-end fw-bold" :class="[light.text]" style="width: 10%; font-size: 12px;">
                                    {{st.pks_disc_dw}}
                                </div>
                                <div class="btn text-end fw-bold" :class="[light.text]" style="width: 10%; font-size: 12px;">
                                    {{st.ux_rtt_jitt}}
                                </div>
                                <div class="btn text-end fw-bold" :class="[light.text]" style="width: 10%; font-size: 12px;">
                                    {{st.ux_rjld}}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
// @ is an alias to /src
import SiteMap from '@/components/apps-components/integrations/customers/sigma/deps/SiteMap.vue'

import axios from "axios";

export default {
  name: 'Level2',
  props:{
    site: String,  
    light: Object,
    mapkey: String
  },
  components: {
    SiteMap
  },
  data(){
    return {
        source: "cato-level-2",
        loading: false,
        maindata :{
            summary:{
                sites:{
                    connected: 0,
                    disabled: 0,
                    disconnected: 0,
                    total: 0
                },
                devices:{
                    connected: 0,
                    disconnected: 0,
                    total: 0
                }
            },
            countries:[],
            geolocation:[],
            disconnected:[],
            internet:{
                summary:{
                    connected: 0,
                    disconnected: 0,
                    total: 0
                },
                bars:[],
                disconnected:[]
            },
            custom_apps:{
                applications: [],
                topflows: [],
                topapps:[]
            },
            network_metrics:{
                updated: "2026-00-00 00:00:00",
                data: []
            }
        },
        mapSettings:{
            key: 1,
            centerLat: 35,
            centerLon: -50,
            zoom: 2,
            theme: 'dark'
        },
        icons: {
          good: { path: require("@/assets/icons/check.png"), size: [20, 20], anchor: [10, 10]},
          bad: { path: require("@/assets/icons/fail.png"), size: [20, 20], anchor: [10, 10]},
          fair: { path: require("@/assets/icons/fair.png"), size: [20, 20], anchor: [10, 10]}
        },
        // Filtering
        country_word: null,
        internet_disconnected_word: null,
        timestamp: null
    }
  },
  methods:{
    getMaindata(){
        this.loading = true
        const params = { source: `${this.source}` }
        const dest = this.site + '/integrations/cato/data'
        axios
            .get(dest, {params})
            .then(rx => {
                // Code
                this.maindata = rx.data.response.data
                this.timestamp = rx.data.response.timestamp
                this.loading = false
                this.stopLoading()
            })
            .catch(error => {
                //this.processErrorMessage(error)
                this.loading = false
                this.stopLoading()
            }); 
    },
    stopLoading(){
        this.$emit('clear-loading-lv2', this.timestamp);
    },
    titlelize(_string){
      return _string.toLowerCase()
            .split('-')
            .map(word => word.charAt(0).toUpperCase() + word.slice(1))
            .join('-');
    },
    renderMap(){
        this.mapSettings.theme = this.light.theme
        this.mapSettings.key += 1;
    },
    getFlag(flagname){
        try{
            return require(`@/assets/flags/${flagname}.png`)
        }
        catch(error){
            return require(`@/assets/flags/_default.png`)
        }
    },
    getMax(array_of_objects, key){
        return Math.max(...array_of_objects.map(item => item[key]));
    },
    getSum(array_of_objects, key){
        let sum = array_of_objects.reduce((accumulator, currentValue) => {
            return accumulator + currentValue[key];
            }, 0);
        return sum.toFixed(2)
    },
    getAvg(array_of_objects, key){
        let sum = array_of_objects.reduce((accumulator, currentValue) => {
            return accumulator + currentValue[key];
            }, 0);
        return (sum / array_of_objects.length).toFixed(2)
    }
  },
  computed:{
    countries(){
        let countries = this.maindata.countries
        if (this.country_word != null){
            countries = countries.filter(element => element.alias.toLowerCase().includes(this.country_word.toLowerCase()))
        }
        return countries
    },
    countries_map(){
        let countries_map = this.maindata.geolocation
        
    },
    disconnected(){
        let disconnected = this.maindata.disconnected
        disconnected = disconnected.filter(element => (!element.operational && !element.connectivity));
        if (this.country_word != null){
            disconnected = disconnected.filter(element => element.alias.toLowerCase().includes(this.country_word.toLowerCase()))
        }
        return disconnected
    },
    internet_disconnected(){
        let internet_disconnected = this.maindata.internet.disconnected
        if (this.internet_disconnected_word != null){
            internet_disconnected = internet_disconnected.filter(element => element.popname.toLowerCase().includes(this.internet_disconnected_word.toLowerCase()))
        }
        return internet_disconnected
    }
  },
  created: function(){
    // Code
    //this.getMaindata()
  },
  mounted: function(){
    // Code
  }
  

}
</script>

<style scoped>

    .cato-main-color{
        color: rgb(67,139, 108);
    }

    .back-darker{
        background-color: rgb(49, 49, 49);
    }

    .border-bottom-light-grey{
        border-bottom: solid rgb(32, 32, 32) 1px
    }

    .bg-bar{
        background-color: rgb(241,175,61);
    }

</style>